<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleCreate"
                >新增</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="type" slot-scope="{ row }">
        <div class="custom-title">
          <span>{{ row.type == 1 ? "图片" : "视频" }}</span>
        </div>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
          v-if="row.image"
        >
        </el-image>
        <!-- <video
          v-if="row.type == 2"
          :src="row.video"
          style="width: 100%; height: 100px"
          controls
        ></video> -->
      </template>
      <template slot="imagePc" slot-scope="{ row }">
        <el-image
          v-if="row.type == 1"
          style="width: 80px; height: 80px"
          :src="row.imagePc"
          :preview-src-list="[row.imagePc]"
        >
        </el-image>
        <video
          v-if="row.type == 2"
          :src="row.videoPc"
          style="width: 100%; height: 100px"
          controls
        ></video>
      </template>
      <template slot="jumpId" slot-scope="{ row }">
        <div>
          {{
            listJump.find(
              (item) =>
                item.id === row.jumpId &&
                Number(item.jumpType) === Number(row.jumpType)
            )?.title || "-"
          }}
        </div>
      </template>

      <template slot="state" slot-scope="{ row }">
        <el-switch
          :value="row.state"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <!-- <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="handleDetails(row)"
          >详情</el-button
        > -->
        <el-button type="text" size="mini" @click="handleEdit(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      v-if="dialogVisible"
      :title="`${form.id ? '修改轮播' : '新增轮播'}`"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form ref="form" v-model="form" :option="formOption">
        <template slot="title">
          <el-input
            v-model="form.title"
            maxlength="20"
            placeholder="请输入"
            onkeyup="this.value=this.value"
            @blur="salaryDianChange($event, 'title')"
            type="text"
            clearable
            :disabled="isDetails"
          />
          <!-- onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)" -->
        </template>

        <template slot="jumpType">
          <el-select
            v-model="form.jumpType"
            clearable
            style="width: 400px"
            :disabled="isDetails"
            @change="(e) => getJumpId(e)"
          >
            <el-option
              v-for="item in jumpTypeList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </template>
        <template slot="jumpId">
          <el-select
            v-model="form.jumpId"
            clearable
            style="width: 400px"
            :disabled="isDetails"
          >
            <el-option
              v-for="item in jumpIdList"
              :key="item.id"
              :value="item.id"
              :label="item.title"
            ></el-option>
          </el-select>
        </template>
        <template slot="image">
          <FormImgUpload
            :url="form.image"
            @upload="upload"
            :limit="1"
            :maxSize="20"
            :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
            :multiple="true"
            :isBanner="false"
            :widthB="750"
            :heightB="600"
          />
          <div style="color: #c0c1c3">
            建议尺寸：750px*600px，图片格式：.png,.jpg,.jpeg,.svg,.tiff
          </div>
        </template>
        <template slot="imagePc">
          <FormImgUpload
            :url="form.imagePc"
            @upload="uploadPc"
            :limit="1"
            :maxSize="20"
            :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
            :multiple="true"
            :isBanner="false"
            :widthB="1920"
            :heightB="960"
          />
          <div style="color: #c0c1c3">
            建议尺寸：1920px*960px，图片格式：.png,.jpg,.jpeg,.svg,.tiff
          </div>
        </template>
        <template slot="video">
          <FormVideoUpload
            :url="form.video"
            @upload="uploadVideo"
            :limit="1"
            :maxSize="500"
            :accept="'.mp4,.webm,.avi'"
            :multiple="false"
          />
          <span style="color: #c0c1c3">
            建议尺寸：750px*600px，最大500M，视频格式：.mp4,.webm,.avi
          </span>
        </template>
        <template slot="videoPc">
          <FormVideoUpload
            :url="form.videoPc"
            @upload="uploadVideoPc"
            :limit="1"
            :maxSize="500"
            :accept="'.mp4,.webm,.avi'"
            :multiple="false"
          />
          <span style="color: #c0c1c3">
            建议尺寸：1920px*960px，最大500M，视频格式：.mp4,.webm,.avi
          </span>
        </template>
        <!-- :maxSize="$store.state.user.uploadView.imageUploadMaxSize"
        :accept="$store.state.user.uploadView.imageUploadFormat"  -->

        <template slot="state">
          <el-switch
            v-if="!isDetails"
            :disabled="isDetails"
            v-model="form.state"
            :inactive-value="2"
            :active-value="1"
          ></el-switch>
          <div v-else>
            {{ form.state == 1 ? "启用中" : form.state == 2 ? "停用中" : "" }}
          </div>
        </template>

        <template slot="menuForm">
          <el-button @click="handleClose">
            {{ isDetails ? "关闭" : "取消" }}</el-button
          >
          <el-button
            type="primary"
            @click="submit(form)"
            :loading="showLoadingForm"
            >确定</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  bannerManageList,
  bannerManageAdd,
  bannerManageUpdate,
  bannerManageDelete,
  bannerManageStateUpdate,
  bannerManageInfoList,
} from "@/api/banner/manage";
import { newsNoticeList } from "@/api/news/notice";
import { mapGetters } from "vuex";

import FormImgUpload from "@/components/formComponents/formImgUpload";
import FormVideoUpload from "@/components/formComponents/formVideoUpload";

export default {
  name: "index",
  components: {
    FormImgUpload,
    FormVideoUpload,
  },
  // computed: {
  // 	...mapGetters(['getButton'])
  // },
  data() {
    return {
      button: {},
      showAuthority: true,
      isDetails: false,
      typeList: [],
      entryList: [],
      searchData: {
        name: "",
        projectId: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "标题",
            prop: "title",
            // fixed: "left",
          },
          {
            label: "类型",
            prop: "type",
            // fixed: "left",
          },
          {
            label: "小程序轮播",
            prop: "image",
            // fixed: "left",
          },
          {
            label: "pc轮播",
            prop: "imagePc",
            // fixed: "left",
          },
          {
            label: "排序值",
            prop: "sort",
          },
          {
            label: "跳转链接",
            prop: "jumpId",
          },
          {
            label: "显示状态",
            prop: "state",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },

      dialogVisible: false,
      form: {
        image: [],
        state: 1,
        type: 1,
        jumpType: null,
        jumpId: null,
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "120",
        row: true,
        column: [
          {
            label: "轮播图片",
            prop: "image",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                trigger: "blur",
                // pc轮播类型：1=图片，2=视频
                // 选择“视频”时，轮播图片(image)不必填；否则必填
                validator: (rule, value, callback) => {
                  const t = this && this.form ? this.form.type : undefined;
                  if (String(t) === "2") return callback();

                  const arr = Array.isArray(value)
                    ? value
                    : value
                    ? [value]
                    : [];
                  if (arr.length === 0) callback(new Error("请上传"));
                  else callback();
                },
              },
            ],
          },
          {
            label: "pc轮播类型",
            prop: "type",
            type: "radio",
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "blur",
              },
            ],
            dicData: [
              {
                value: 1,
                label: "图片",
              },
              {
                value: 2,
                label: "视频",
              },
            ],
          },
          {
            label: "pc轮播图片",
            prop: "imagePc",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          // {
          //   label: "h5轮播视频",
          //   prop: "video",
          //   type: "text",
          //   maxlength: 50,
          //   span: 24,
          //   display: false,
          //   rules: [
          //     {
          //       required: true,
          //       message: "请上传",
          //       trigger: "blur",
          //     },
          //     {
          //       validator: (rule, value, callback) => {
          //         if (value.length === 0) {
          //           callback(new Error("请上传"));
          //         } else {
          //           callback();
          //         }
          //       },
          //     },
          //   ],
          // },
          {
            label: "pc轮播视频",
            prop: "videoPc",
            type: "text",
            maxlength: 50,
            span: 24,
            display: false,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "轮播标题",
            prop: "title",
            type: "text",
            maxlength: 200,
            placeholder: "请输入",
            span: 16,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "跳转类型",
            prop: "jumpType",
            type: "text",
            maxlength: 100,
            placeholder: "请输入",
            span: 16,
          },
          {
            label: "跳转链接",
            prop: "jumpId",
            type: "text",
            maxlength: 100,
            placeholder: "请输入",
            span: 16,
          },
          {
            label: "排序",
            prop: "sort",
            type: "number",
            maxRows: 999999,
            minRows: 1,
            span: 16,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入排序",
                trigger: "blur",
              },
            ],
          },

          // {
          //   label: "排序",
          //   prop: "sort",
          //   type: "number",
          //   maxRows: 999999,
          //   minRows: 1,
          //   placeholder: "请输入",
          //   width: "300px",
          //   span: 24,
          //   rules: [
          //     {
          //       required: true,
          //       message: "请输入排序",
          //       trigger: "blur",
          //     },
          //   ],
          // },
          {
            label: "显示状态",
            prop: "state",
            type: "text",
            maxlength: 100,
            span: 24,
            rules: [
              {
                required: true,
                message: "",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      dialogPassWordVisible: false,
      dataUrl: "",
      jumpTypeList: [
        {
          id: 1,
          name: "新闻资讯",
        },
        {
          id: 2,
          name: "产品公告",
        },
      ], //跳转类型列表
      jumpIdList: [], //跳转链接列表
      listJump: [],
    };
  },
  watch: {
    "form.type"(val) {
      // pc轮播类型：1=图片，2=视频
      // 选择“视频”时，“轮播图片(image)”不必填，否则必填
      const imageCol = this.findObject(this.formOption.column, "image");
      if (imageCol) {
        if (val == 2) {
          imageCol.rules = [
            {
              trigger: "blur",
              validator: (rule, value, callback) => callback(),
            },
          ];
        } else {
          imageCol.rules = [
            {
              trigger: "blur",
              validator: (rule, value, callback) => {
                const arr = Array.isArray(value) ? value : value ? [value] : [];
                if (arr.length === 0) callback(new Error("请上传"));
                else callback();
              },
            },
          ];
        }
      }

      if (val == 1) {
        // const image = this.findObject(this.formOption.column, "image");
        const imagePC = this.findObject(this.formOption.column, "imagePc");
        const videoPC = this.findObject(this.formOption.column, "videoPc");
        videoPC.display = false;
        imagePC.display = true;
      } else {
        const imagePC = this.findObject(this.formOption.column, "imagePc");
        const videoPC = this.findObject(this.formOption.column, "videoPc");
        videoPC.display = true;
        imagePC.display = false;
      }
    },
  },
  created() {
    this.getListJump();
  },
  methods: {
    // 列表匹配回显（新闻资讯 + 产品公告，按 jumpType 区分）
    getListJump() {
      return Promise.all([
        bannerManageInfoList({}),
        newsNoticeList({ page: 1, size: 999 }),
      ]).then(([res1, res2]) => {
        const news =
          res1.code === 200
            ? Array.isArray(res1.data)
              ? res1.data
              : res1.data?.records || []
            : [];
        const notices =
          res2.code === 200 && res2.data?.records ? res2.data.records : [];
        this.listJump = [
          ...news.map((item) => ({ ...item, jumpType: 1 })),
          ...notices.map((item) => ({ ...item, jumpType: 2 })),
        ];
      });
    },
    //初始化
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      this.showLoading = true;
      bannerManageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },
    // PC端
    uploadPc(e) {
      if (Array.isArray(e)) {
        this.form.imagePc = [...e];
      } else {
        this.form.imagePc = [...this.form.imagePc, e];
      }
    },

    //图片上传
    uploadVideo(e) {
      if (Array.isArray(e)) {
        this.form.video = [...e];
      } else {
        this.form.video = [...this.form.video, e];
      }
    },
    // PC端
    uploadVideoPc(e) {
      console.log(e, "xxxxxxxxx");

      if (Array.isArray(e)) {
        this.form.videoPc = [...e];
      } else {
        this.form.videoPc = [...this.form.videoPc, e];
      }
    },
    // 添加
    handleCreate() {
      this.form.image = [];
      this.form.imagePc = [];
      this.form.type = 1;
      this.isDetails = false;
      this.form.id = "";
      this.dialogVisible = true;
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      // localStorage.removeItem("searchForm");
      this.searchData = {
        title: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    //编辑
    async handleEdit(row) {
      // console.log(row)
      this.isDetails = false;
      this.form = {
        ...row,
        image: row.image ? [row.image] : [],
        imagePc: row.imagePc ? [row.imagePc] : [],
        // video: row.video ? [row.video] : [],
        videoPc: row.videoPc ? [row.videoPc] : [],
        jumpType: row.jumpType || "",
      };
      this.form.id = row.id;
      if (row.jumpType) {
        await this.getJumpIdList();
      }

      this.dialogVisible = true;
    },

    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        bannerManageDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
      };
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          // return
          if (form.id) {
            bannerManageUpdate({
              ...form,
              image: form.image[0] || "",

              imagePc: form.type == 1 ? form.imagePc[0] : "",
              jumpType: form.jumpType || 0,
              videoPc: form.type == 2 ? form.videoPc[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                }
                this.showLoadingForm = false;
              })
              .catch(() => (this.showLoadingForm = false));
          } else {
            bannerManageAdd({
              ...form,
              image: form.image[0] || "",
              imagePc: form.type == 1 ? form.imagePc[0] : "",
              jumpType: form.jumpType || 0,
              videoPc: form.type == 2 ? form.videoPc[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                }
                this.showLoadingForm = false;
              })
              .catch(() => (this.showLoadingForm = false));
          }
          // this.form.type = 1;
          // done()
        }
      });
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },

    handlePassWordClose() {
      this.dialogPassWordVisible = false;
    },
    //切换是否显示
    handleSwitch(e, id) {
      bannerManageStateUpdate({
        id: id,
        state: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },
    // 获取跳转类型
    getJumpType() {
      this.jumpTypeList = [];
    },
    // 获取跳转链接（切换跳转类型时清空已选跳转链接）
    getJumpId(e) {
      this.form.jumpId = "";
      if (e) {
        this.getJumpIdList();
      } else {
        this.jumpIdList = [];
      }
    },
    // 获取跳转链接列表：1 新闻资讯；2 产品公告（/web/news/notice/list）
    getJumpIdList() {
      if (this.form.jumpType == 2) {
        return newsNoticeList({ page: 1, size: 999 }).then((res) => {
          if (res.code === 200) {
            this.jumpIdList = res.data.records || [];
          }
        });
      }
      return bannerManageInfoList({}).then((res) => {
        if (res.code === 200) {
          this.jumpIdList = Array.isArray(res.data)
            ? res.data
            : res.data?.records || [];
        }
      });
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
</style>
